import { DOCUMENT } from "@angular/common";
import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../environments/environment";

const SUPPORTED_LANGUAGES = ["en", "fr", "ar"] as const;
type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

@Injectable({ providedIn: "root" })
export class LanguageLayoutService {
  constructor(
    private readonly translate: TranslateService,
    @Inject(DOCUMENT) private readonly document: Document,
  ) {
    const language = this.resolveLanguage(sessionStorage.getItem("lang"));
    sessionStorage.setItem("lang", language);
    this.translate.addLangs([...SUPPORTED_LANGUAGES]);
    this.translate.setDefaultLang(environment.defaultLang);
    this.applyDirection(language);
    void this.translate.use(language);
    this.translate.onLangChange.subscribe(({ lang }) => {
      const supported = this.resolveLanguage(lang);
      sessionStorage.setItem("lang", supported);
      this.applyDirection(supported);
    });
  }

  private resolveLanguage(
    language: string | null | undefined,
  ): SupportedLanguage {
    const normalized = language?.split("-")[0] as SupportedLanguage | undefined;
    return normalized && SUPPORTED_LANGUAGES.includes(normalized)
      ? normalized
      : (environment.defaultLang as SupportedLanguage);
  }

  private applyDirection(language: SupportedLanguage): void {
    const html = this.document.documentElement;
    const direction = language === "ar" ? "rtl" : "ltr";
    html.lang = language;
    html.dir = direction;
    html.classList.toggle("rtl", direction === "rtl");
    html.classList.toggle("ltr", direction === "ltr");
    html.style.direction = direction;
    window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
  }
}
